import { FC } from 'react';

import {
  SITE_PIN_COLOUR,
  SITE_PIN_PATH,
  SITE_PIN_SHADOW,
  SITE_PIN_VIEW_BOX,
} from './siteLocationMarkerArt';

const SiteLocationMarker: FC = () => (
  <svg
    aria-hidden="true"
    className="pointer-events-none absolute left-1/2 top-1/2 h-auto w-8 -translate-x-1/2 -translate-y-full"
    focusable="false"
    style={{ filter: SITE_PIN_SHADOW }}
    viewBox={SITE_PIN_VIEW_BOX}
  >
    <path
      d={SITE_PIN_PATH}
      fill={SITE_PIN_COLOUR}
      stroke="white"
      strokeWidth="2.5"
    />
    <circle cx="17" cy="17" fill="white" r="5.5" />
  </svg>
);

export default SiteLocationMarker;
